import { render, staticRenderFns } from "./SwitchOrderToOrderLines.vue?vue&type=template&id=b619cff0"
import script from "../script/orders/switchOrdersToOrderLines.js?vue&type=script&lang=js&external"
export * from "../script/orders/switchOrdersToOrderLines.js?vue&type=script&lang=js&external"
import style0 from "../less/orders/switchOrdersToOrderLines.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports